export default __webpack_public_path__ + "static/media/mlop.abd47113.svg";